export default "__VITE_ASSET__57b32814__"